import { ConnectionType } from 'types/Connection'

export type GoogleAuthServiceType =
  | ConnectionType.GOOGLE_ANALYTICS
  | ConnectionType.GMAIL

export const googleAnalyticsScopes = [
  'https://www.googleapis.com/auth/analytics.readonly',
  'https://www.googleapis.com/auth/analytics',
]

export const gmailScopes = [
  'https://www.googleapis.com/auth/gmail.readonly',
  // 'https://www.googleapis.com/auth/gmail.modify',
  // 'https://www.googleapis.com/auth/gmail.compose',
  // 'https://www.googleapis.com/auth/gmail.send',
  'email',
]

export const googleAccountScopes = [
  'https://www.googleapis.com/auth/userinfo.email',
  'https://www.googleapis.com/auth/userinfo.profile',
  'openid',
]

export const checkIfAllScopesAreGranted = (scopes: string[]) => {
  return scopes.every(scope => gmailScopes.includes(scope))
}

export const checkIfAnyGoogleAnalyticsScopesAreGranted = (scopes: string[]) => {
  return scopes.some(scope => googleAnalyticsScopes.includes(scope))
}

export const checkIfAnyGmailScopesAreGranted = (scopes: string[]) => {
  return scopes.some(scope => gmailScopes.includes(scope))
}

export const findWhichGoogleServiceScopesAreGranted = (
  grantedScopes: string[]
) => {
  let googleAuthServiceType = null

  const googleAnalyticsScopesGranted =
    checkIfAnyGoogleAnalyticsScopesAreGranted(grantedScopes)
  const gmailScopesGranted = checkIfAnyGmailScopesAreGranted(grantedScopes)

  if (googleAnalyticsScopesGranted) {
    googleAuthServiceType = ConnectionType.GOOGLE_ANALYTICS
  } else if (gmailScopesGranted) {
    googleAuthServiceType = ConnectionType.GMAIL
  }

  return googleAuthServiceType
}

export const checkGoogleServiceScopes = (
  grantedScopes: string[],
  serviceType: GoogleAuthServiceType
) => {
  let requiredScopes: string[] = []

  if (serviceType === ConnectionType.GOOGLE_ANALYTICS) {
    requiredScopes = googleAnalyticsScopes
  } else if (serviceType === ConnectionType.GMAIL) {
    requiredScopes = gmailScopes
  }

  // Check if any of the required scopes are granted
  const anyGranted = grantedScopes.some(scope => requiredScopes.includes(scope))

  // Check if all of the required scopes are granted
  const allGranted = requiredScopes.every(scope =>
    grantedScopes.includes(scope)
  )

  return {
    anyGranted,
    allGranted,
  }
}
